// extracted by mini-css-extract-plugin
export var header = "_fa-0";